"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lineOptions_1 = __importDefault(require("./Line/lineOptions"));
var areaOptions_1 = __importDefault(require("./Area/areaOptions"));
var areaRangeOptions_1 = __importDefault(require("./AreaRange/areaRangeOptions"));
var columnOptions_1 = __importDefault(require("./Column/columnOptions"));
var candleStickOptions_1 = __importDefault(require("./CandleStick/candleStickOptions"));
var columnRangeOptions_1 = __importDefault(require("./ColumnRange/columnRangeOptions"));
var barOptions_1 = __importDefault(require("./Bar/barOptions"));
var bulletOptions_1 = __importDefault(require("./Bullet/bulletOptions"));
var pieOptions_1 = __importDefault(require("./Pie/pieOptions"));
var donutOptions_1 = __importDefault(require("./Donut/donutOptions"));
var scatterOptions_1 = __importDefault(require("./Scatter/scatterOptions"));
var heatmapOptions_1 = __importDefault(require("./Heatmap/heatmapOptions"));
var gaugeOptions_1 = __importDefault(require("./Gauge/gaugeOptions"));
function default_1(series, tooltip, initialRun) {
    var options = [];
    if (series && series.length) {
        var donutCount_1 = 0;
        options = series.map(function (seriesComponent) {
            var type = seriesComponent.props.type;
            var seriesOptions;
            switch (type) {
                case 'line':
                    seriesOptions = lineOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'area':
                    seriesOptions = areaOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'arearange':
                    seriesOptions = areaRangeOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'column':
                    seriesOptions = columnOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'columnrange':
                    seriesOptions = columnRangeOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'candlestick':
                    seriesOptions = candleStickOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'bar':
                    seriesOptions = barOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'bullet':
                    seriesOptions = bulletOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'scatter':
                    seriesOptions = scatterOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'pie':
                    seriesOptions = pieOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'heatmap':
                    seriesOptions = heatmapOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'solidgauge':
                    seriesOptions = gaugeOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'gauge':
                    seriesOptions = gaugeOptions_1.default(seriesComponent, tooltip, initialRun);
                    break;
                case 'donut':
                    seriesOptions = donutOptions_1.default(seriesComponent, donutCount_1, tooltip, initialRun);
                    donutCount_1 += 1;
                    break;
                default:
                    seriesOptions = {};
                    break;
            }
            return seriesOptions;
        });
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=seriesOptions.js.map